module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0b09fe426a0a8dec90cedaf030040d4f.png";